import { createAction, props, union } from '@ngrx/store';

export const selectCustomer = createAction('[AssignmentFilter] SELECT_CUSTOMER', props<{ customerId: number }>());
export const setFilterFormExpanded = createAction('[AssignmentFilter] SET_FILTER_FORM_EXPANDED', props<{ expanded: boolean }>());

export const AssignmentFilterActions = union({
  selectCustomer, setFilterFormExpanded,
});
